export default "__VITE_ASSET__De14U3tT__"